
/**
 * WizardFooter - Navigation buttons for wizard
 *
 * Features:
 * - Back button (disabled on step 1)
 * - Next button (enabled when step is valid)
 *
 * Design:
 * - Primary button: Emerald-500 (#10B981) background, white text
 * - Secondary button: Gray border, gray text
 * - Disabled state: Gray-300 background, cursor not-allowed
 * - 8px base spacing (px-4 = 16px, py-2 = 8px)
 */
const WizardFooter = ({
  currentStep,
  onBack,
  onNext,
  isStepValid = true,
  isLastStep = false,
}) => {
  // First step cannot go back
  const canGoBack = currentStep > 1;

  // Button text changes on last step
  const nextButtonText = isLastStep ? 'Fertigstellen' : 'Weiter →';

  return (
    <div className="px-6 py-4 border-t border-gray-200 bg-white">
      <div className="flex items-center justify-between">
        {/* Left: Back Button */}
        <button
          onClick={onBack}
          disabled={!canGoBack}
          className={`
            px-4 py-2 border rounded font-medium text-sm transition-all font-inter
            ${
              canGoBack
                ? 'border-gray-300 text-gray-700 hover:bg-gray-100 hover:border-gray-400'
                : 'border-gray-200 text-gray-400 cursor-not-allowed'
            }
          `}
          aria-label="Zurück zum vorherigen Schritt"
          data-testid="wizard-back-btn"
        >
          ← Zurück
        </button>

        {/* Right: Next Button */}
        <div>
          {/* Next Button */}
          <button
            onClick={onNext}
            disabled={!isStepValid}
            className={`
              px-4 py-2 rounded font-medium text-sm transition-all font-inter
              ${
                isStepValid
                  ? 'bg-emerald-500 text-white hover:bg-emerald-600 active:bg-emerald-700'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }
            `}
            aria-label={isLastStep ? 'Assistent abschließen' : 'Weiter zum nächsten Schritt'}
            data-testid={isLastStep ? 'wizard-complete-btn' : 'wizard-next-btn'}
          >
            {nextButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WizardFooter;
